import GenericDB from './generic-db'

export default class AccountClientCampaignsDB extends GenericDB {
  constructor(accountId, clientId) {
    super(`accounts/${accountId}/clients/${clientId}/campaigns`)
  }

  // Here you can extend AccountClientCampaignsDB with custom methods
}
